<template>
    <div :class="className + '-crop-container'">
        <div class="mb-4">
            <v-image-upload-button
                :label-id="className+'-image-upload-button-label'"
                :input-id="className+'-image-upload-button-input'"
                @upload="handleUpload"
                ref="button"
            >
            </v-image-upload-button>
        </div>
        <vue-cropper
            ref="cropper"
            :auto-crop-area="autoCropArea"
            :view-mode="viewMode"
            :drag-mode="dragMode"
            :aspect-ratio="aspectRatio"
            :background="background"
            :rotable="rotable"
            :npguides="npguides"
            :src="src"
            :img-style="size"
            v-if="src !== ''">
        </vue-cropper>
    </div>
</template>

<script>

    import Vue from 'vue';
    import VueCropper from 'vue-cropperjs';
    import 'cropperjs/dist/cropper.css';
    import LoadingButtonVue from './LoadingButton.vue';
    import imageUploadMixin from './image-upload-mixin';
    import ImageUploaderButtonVue from './ImageUploaderButton.vue';

    export default {
        components: {
            VueCropper,
            'v-image-upload-button': ImageUploaderButtonVue,
            'v-loading-button': LoadingButtonVue
        },
        data() {
            return {
                src: '',
                cropped: ''
            }
        },
        props: {
            current: {
                type: String,
                default: ''
            },
            className: {
                type: String,
                default: 'crop'
            },
            size: {
                type: Object,
                default() {
                    return {
                        width: '100px',
                        height: '100px'
                    }
                }
            },
            cropSize: {
                type: Object,
                default() {
                    return {
                        width: parseInt(this.size.width),
                        height: parseInt(this.size.height),
                    }
                }
            },
            autoCropArea: {
                type: Number,
                default: 1
            },
            viewMode: {
                type: Number,
                default: 2
            },
            dragMode: {
                type: String,
                default: 'crop'
            },
            aspectRatio: {
                type: Number,
                default: 1
            },
            background: {
                type: Boolean,
                default: true
            },
            rotable: {
                type: Boolean,
                default: false
            },
            npguides: {
                type: Boolean,
                default: true
            }
        },
        mixins: [imageUploadMixin],
        methods: {
            handleUpload(files) {
                const file = this.$refs.button.getFile();

                if ( ! file.type.includes('image/') ) {
                    alert('Please select an image file');
                    return;
                }

                this.getBase64ForImage(file)
                    .then((image) => {
                        this.setImage(image);
                    });
            },

            setImage(src)
            {
                this.src = src;
                Vue.nextTick()
                    .then(() => {
                        this.$refs.cropper.replace(this.src);
                    });
            },

            getCroppedResult()
            {
                this.cropped = this.$refs.cropper.getCroppedCanvas({
                    width: parseInt(this.cropSize.width),
                    height: parseInt(this.cropSize.height),
                    fillColor: '#FFFFFF',
                    imageSmoothingEnabled: true,
                    imageSmoothingQuality: 'high',
                }).toDataURL('image/jpeg');
                return this.cropped;
            }

        },
        mounted()
        {
            if ( this.current !== '' ) {
                this.setImage(this.current);
            }
        }
    }
</script>